import Script from 'next/script';
import { ValidatedScripts } from '../response-data-validator';
interface Props {
  goftinoData: ValidatedScripts['goftino'];
}
export const GoftinoScript = ({
  goftinoData
}: Props) => {
  if (!goftinoData?.enabled) return null;
  return <Script defer strategy='lazyOnload' id='goftino' dangerouslySetInnerHTML={{
    __html: `!function () { var i = "i9HLqX", a = window, d = document; function g() { var g = d.createElement("script"), s = "https://www.goftino.com/widget/" + i, l = localStorage.getItem("goftino_" + i); g.async = !0, g.src = l ? s + "?o=" + l : s; d.getElementsByTagName("head")[0].appendChild(g); } "complete" === d.readyState ? g() : a.attachEvent ? a.attachEvent("onload", g) : a.addEventListener("load", g, !1); }();`
  }} data-sentry-element="Script" data-sentry-component="GoftinoScript" data-sentry-source-file="goftino.tsx" />;
};